import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import { Box, CircularProgress } from "@mui/material";

import { fetchAboutUs } from "../redux/actions/aboutUsAction";
import { useAppDispatch } from "../redux/hook";
import { getVideoId } from "../utils/utils";

import "../../node_modules/react-modal-video/css/modal-video.css";

export default function AboutDetail() {
  const dispatch = useAppDispatch();

  const [isOpen, setOpen] = useState(false);
  const [aboutUsData, setAboutUsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAboutUs = async () => {
      const aboutUs = await dispatch(fetchAboutUs());

      if (typeof aboutUs.payload === "string") {
        setLoading(false);
        // navigate(checkError(homeEdit.payload));
      } else {
        setLoading(false);
        setAboutUsData(aboutUs.payload[0]);
      }
    };
    loadAboutUs();
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="container relative">
      <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <img
              src={
                process.env.REACT_APP_API_URL +
                "/wwwroot/images/" +
                aboutUsData.image_file_02
              }
              className="rounded-lg shadow-lg relative"
              alt=""
            />
            <div className="absolute bottom-2/4 translate-y-2/4 end-0 start-0 text-center">
              <Link
                to="#!"
                onClick={() => setOpen(true)}
                className="lightbox h-20 w-20 rounded-full shadow-lg shadow-slate-100 dark:shadow-slate-800 inline-flex items-center justify-center bg-white dark:bg-slate-950 text-orange-500"
              >
                <i className="mdi mdi-play inline-flex items-center justify-center text-2xl"></i>
              </Link>
            </div>
            <ModalVideo
              channel="youtube"
              youtube={{ mute: 0, autoplay: 0 }}
              isOpen={isOpen}
              videoId={getVideoId(aboutUsData.video)}
              onClose={() => setOpen(false)}
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="lg:ms-7">
            <h3 className="mb-4 md:text-2xl text-xl font-medium">
              {aboutUsData.title}
            </h3>

            <p className="text-slate-400 dark:text-white/60 max-w-2xl mx-auto">
              {aboutUsData.content}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
